<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<v-card flat :loading="loading">
					<v-card-title> Registro de plano de ação </v-card-title>

					<v-card-text>
						Selecione o planejamento estratégico para continuar...

						<v-row class="mt-5">
							<v-col cols="12" md="3">
								<v-select
									v-model="filter.company"
									:items="companies"
									item-text="DESEMP"
									item-value="CODEMP"
									label="Empresa"
									:loading="loadingCompany"
									@change="getUnits"
								></v-select>
							</v-col>
							<v-col cols="12" md="3">
								<v-select
									v-model="filter.unit"
									:items="units"
									item-text="DESUNI"
									item-value="CODUNI"
									label="Unidade"
									:loading="loadingUnit"
								></v-select>
							</v-col>
							<v-col cols="12" md="3">
								<v-select
									v-model="filter.strategicPlanning"
									:items="strategicPlannings"
									item-text="DESPLE"
									item-value="CODPLE"
									label="Planejamento estrategico"
									:loading="loadingPlanning"
									hide-details
								></v-select>
							</v-col>

							<v-col cols="12" md="3">
								<v-btn
									class="white--text mt-3"
									depressed
									color="info"
									@click="getPlans()"
									:loading="loading"
									>Buscar</v-btn
								>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12">
				<v-card flat :loading="loading">
					<v-card-title> Responsável </v-card-title>

					<v-card-text>
						<v-data-table
							v-show="dataResponsible.length > 0"
							:headers="headers"
							:items="dataResponsible"
							:loading="loading"
							item-key="name"
							sort-by="name"
							:group-by="['area.DESARE']"
							class="elevation-0"
							hide-default-footer
							disable-pagination
						>
							<template v-slot:group="{ items }">
								<tr class="aggroup">
									<td class="text-xs-right" :colspan="headers.length">
										<strong>{{
											items[0].company.DESEMP +
											" > " +
											items[0].unit.DESUNI +
											" > " +
											items[0].area.DESARE
										}}</strong>
									</td>
								</tr>
								<tr
									class="aggroupLine"
									v-for="item in items"
									:key="item.CODPLA"
								>
									<td
										v-for="(header, idx) in headers"
										:key="idx"
										:align="header.align"
										class="borderRight divToClick"
										style="padding: 0px"
										@click="
											openRegistration(header, item, typeBloc.responsible)
										"
									>
										<span class="pl-3">
											{{ getValue(header, item) }}
										</span>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12">
				<v-card flat :loading="loading">
					<v-card-title> Áreas </v-card-title>

					<v-card-text>
						<v-data-table
							v-show="dataCategory.length > 0"
							:headers="headers"
							:items="dataCategory"
							:loading="loading"
							item-key="name"
							sort-by="name"
							:group-by="['area.DESARE']"
							class="elevation-0"
							hide-default-footer
							disable-pagination
						>
							<template v-slot:group="{ items }">
								<tr class="aggroup">
									<td class="text-xs-right" :colspan="headers.length">
										<strong>{{
											items[0].company.DESEMP +
											" > " +
											items[0].unit.DESUNI +
											" > " +
											items[0].area.DESARE
										}}</strong>
									</td>
								</tr>
								<tr
									class="aggroupLine"
									v-for="item in items"
									:key="item.CODPLA"
								>
									<td
										v-for="(header, idx) in headers"
										:key="idx"
										:align="header.align"
										class="borderRight divToClick"
										style="padding: 0px"
										@click="openRegistration(header, item, typeBloc.area)"
									>
										<span class="pl-3">
											{{ getValue(header, item) }}
										</span>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12">
				<v-card flat :loading="loading">
					<v-card-title> Envolvidos </v-card-title>

					<v-card-text>
						<v-data-table
							v-show="dataInvolved.length > 0"
							:headers="headers"
							:items="dataInvolved"
							:loading="loading"
							item-key="name"
							sort-by="name"
							:group-by="['area.DESARE']"
							class="elevation-0"
							hide-default-footer
							disable-pagination
						>
							<template v-slot:group="{ items }">
								<tr class="aggroup">
									<td class="text-xs-right" :colspan="headers.length">
										<strong>{{
											items[0].company.DESEMP +
											" > " +
											items[0].unit.DESUNI +
											" > " +
											items[0].area.DESARE
										}}</strong>
									</td>
								</tr>
								<tr
									class="aggroupLine"
									v-for="item in items"
									:key="item.CODPLA"
								>
									<td
										v-for="(header, idx) in headers"
										:key="idx"
										:align="header.align"
										class="borderRight divToClick"
										style="padding: 0px"
										@click="openRegistration(header, item, typeBloc.involved)"
									>
										<span class="pl-3">
											{{ getValue(header, item) }}
										</span>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<RegistrationModel
			ref="RegistrationModel"
			v-on:close="closeRegistration"
			:listTasks="listTasks"
			:listTasksAll="listTasksAll"
			:loadTask="loadTask"
		/>
	</v-container>
</template>

<script>
import moment from "moment";

import RegistrationModel from "./RegistrationModal.vue";

import PlanActionService from "../../app/Services/PlanActionService";
import PlanActionRegistrationService from "../../app/Services/PlanActionRegistrationService";
import CompanyService from "../../app/Services/CompanyService";
import UnitService from "../../app/Services/UnitService";
import StrategicPlanningService from "../../app/Services/StrategicPlanningService";
import PlanActionTaskService from "./../../app/Services/PlanActionTaskService";

const planActionService = PlanActionService.build();
const planActionRegistration = PlanActionRegistrationService.build();
const companyService = CompanyService.build();
const unitService = UnitService.build();
const strategicPlanningService = StrategicPlanningService.build();
const planActionTaskService = PlanActionTaskService.build();

export default {
	name: "PlanActionRegister",
	components: {
		RegistrationModel: RegistrationModel,
	},
	data: () => ({
		loading: false,
		loadingCompany: false,
		loadingUnit: false,
		loadingPlanning: false,
		registerPlanAction: false,
		editValues: false,
		loadingPlanningRegistration: false,
		strategicPlannings: [],
		companies: [],
		units: [],
		itens: [],
		dataResponsible: [],
		dataCategory: [],
		dataInvolved: [],
		registrationPlanning: [],
		typeBloc: {
			responsible: "responsible",
			area: "area",
			involved: "involved",
		},
		status: [
			{ id: "A", description: "Aberto" },
			{ id: "F", description: "Fechado" },
		],
		filter: {
			company: "",
			unit: "",
			strategicPlanning: "",
		},
		registration: {
			id: null,
			companyName: "",
			unitName: "",
			planningName: "",
			areaName: "",
			message: "",
			percent: 0,
			status: "",
		},
		planningHeaders: [
			{ text: "Data", align: "center", sortable: false, width: "12%" },
			{ text: "Hora", align: "center", sortable: false, width: "12%" },
			{ text: "Usuário", align: "center", sortable: false, width: "15%" },
			{ text: "Descrição", align: "left", sortable: false },
		],
		userData: {},
		listTasks: [],
		listTasksAll: [],
		loadTask: true,
		defaultValues: {},
	}),
	mounted() {
		this.defaultValues = JSON.parse(localStorage.getItem("default_filters"));
		this.getCompanies();
		this.getStrategicPlannings();

		this.userData = JSON.parse(localStorage.getItem("user"));

		if (this.userData) {
			this.editValues =
				this.userData.user.TIPUSU === "E" || this.userData.user.TIPUSU === "G";
		}
	},
	computed: {
		headers() {
			const headers = [];

			headers.push({
				text: "Descrição",
				align: "start",
				type: "fixed",
				valueType: "text",
				value: "DESPLA",
				sortable: false,
				groupable: false,
			});
			headers.push({
				text: "Indicador",
				align: "start",
				type: "fixed",
				valueType: "text",
				value: "indicator",
				sortable: false,
				groupable: false,
			});
			headers.push({
				text: "Objetivo",
				align: "start",
				type: "fixed",
				valueType: "text",
				value: "objective",
				newDescription: "DESOBJ",
				sortable: false,
				groupable: false,
			});
			headers.push({
				text: "Prev. Inicio",
				align: "center",
				type: "fixed",
				valueType: "date",
				value: "QNDINI",
				width: "7%",
				sortable: false,
				groupable: false,
			});
			headers.push({
				text: "Prev. Fim",
				align: "center",
				type: "fixed",
				valueType: "date",
				value: "QNDFIN",
				width: "7%",
				sortable: false,
				groupable: false,
			});
			headers.push({
				text: "Quem fará",
				align: "start",
				type: "fixed",
				valueType: "text",
				value: "user",
				newDescription: "NOMUSU",
				width: "30%",
				sortable: false,
				groupable: false,
			});
			headers.push({
				text: "% Executado",
				align: "center",
				type: "fixed",
				valueType: "number",
				value: "PEREXE",
				width: "12%",
				sortable: false,
				groupable: false,
			});

			return headers;
		},
	},
	methods: {
		getValue(header, item) {
			switch (header.valueType) {
				case "date":
					return this.formatDate(item[header.value]) || "";
				case "number":
					return this.formatNumber(item[header.value]);
				default:
					if (header.value == "objective" && item[header.value] != null) {
						return item[header.value][header.newDescription];
					} else if (header.value == "user" && item[header.value] != null) {
						return item[header.value][header.newDescription];
					} else if (header.value == "indicator") {
						return item[header.value] ? item[header.value].DESIND : "";
					} else return item[header.value];
			}
		},
		toast(type, message, icon = "mdi-check") {
			this.$toasted.show(message, {
				type: type,
				icon: icon,
			});
		},
		getCompanies() {
			this.loadingCompany = true;
			return companyService.search({}).then((response) => {
				this.companies = response;

				if (this.companies.length === 1 || this.defaultValues.CODEMP) {
					this.filter.company =
						this.defaultValues.CODEMP ?? this.companies[0].CODEMP;
					this.getUnits();

					this.checkAndSearch();
				}

				this.loadingCompany = false;
			});
		},
		getUnits() {
			const search = {};

			this.units = [];
			this.loadingUnit = true;

			if (this.filter.company) {
				search.company = this.filter.company;
			}

			return unitService.search(search).then((response) => {
				this.units = response;

				if (this.units.length === 1 || this.defaultValues.CODUNI) {
					this.filter.unit = this.defaultValues.CODUNI ?? this.units[0].CODUNI;

					this.checkAndSearch();
				}

				this.loadingUnit = false;
			});
		},
		getPlans() {
			if (!this.filter.company) {
				this.toast("warning", "Informe a empresa para continuar");
				return;
			}

			if (!this.filter.unit) {
				this.toast("warning", "Informe a unidade para continuar");
				return;
			}

			if (!this.filter.strategicPlanning) {
				this.toast(
					"warning",
					"Informe o planejamento estrategico para continuar"
				);
				return;
			}

			this.filter.status = "A";
			this.filter.loadBlocs = true;
			this.loading = true;
			this.dataResponsible = [];
			this.dataCategory = [];
			this.dataInvolved = [];

			Promise.all([planActionService.search(this.filter)]).then((response) => {
				this.dataResponsible = response[0].responsible || [];
				this.dataCategory = response[0].category || [];
				this.dataInvolved = response[0].involved || [];

				this.loading = false;
			});
		},
		getStrategicPlannings() {
			this.loadingPlanning = true;

			const userData = JSON.parse(localStorage.getItem("user"));

			strategicPlanningService
				.getPlanning({ codusu: userData.user.CODUSU })
				.then((response) => {
					this.strategicPlannings = response;

					if (
						this.strategicPlannings.length === 1 ||
						this.defaultValues.CODPLE
					) {
						this.filter.strategicPlanning =
							this.defaultValues.CODPLE ?? this.strategicPlannings[0].CODPLE;

						this.checkAndSearch();
					}

					this.loadingPlanning = false;
				});
		},
		checkAndSearch() {
			if (
				this.filter.company &&
				this.filter.unit &&
				this.filter.strategicPlanning
			) {
				this.getPlans();
			}
		},
		formatDate(value) {
			return moment(value).format("DD/MM/YYYY");
		},
		formatNumber(value) {
			return this.numeral(parseFloat(value)).format("0,0.00");
		},
		openRegistration(header, item, _typeBloc) {
			let isEdit = true;
			this.loadTask = true;
			this.listTasks = [];
			this.listTasksAll = [];

			if (_typeBloc == this.typeBloc.area && this.userData.user.TIPUSU == "P") {
				isEdit = false;
			}

			planActionTaskService.getArrayTasks(item.CODPLA, "A").then((response) => {
				this.listTasks = response;

				planActionTaskService.getArrayTasks(item.CODPLA).then((responseAll) => {
					this.listTasksAll = responseAll;
					this.loadTask = false;
				});
			});

			this.$refs.RegistrationModel.openRegistration(item, isEdit);
			// this.registration.companyName = item.company.DESEMP;
			// this.registration.unitName = item.unit.DESUNI;
			// this.registration.planning = item.CODPLA;
			// this.registration.planningName = item.strategicplanning.DESPLE;
			// this.registration.areaName = item.area.DESARE;
			// this.registration.percent = parseFloat(item.PEREXE);
			// this.registration.status = item.STATUS;

			// this.registerPlanAction = true;

			// this.getRegistration(item.CODPLA);
		},
		closeRegistration() {
			this.registerPlanAction = false;
			this.clearRegistration();
			this.getPlans();
		},
		clearRegistration() {
			this.registration.id = null;
			this.registration.companyName = "";
			this.registration.unitName = "";
			this.registration.planning = "";
			this.registration.planningName = "";
			this.registration.areaName = "";
			this.registration.message = "";
			this.registration.percent = 0;
			this.registration.status = "";
		},
		confirmRegistration() {
			if (!this.registration.message) {
				this.toast("warning", "Informe a descrição para continuar");
				return;
			}

			const data = {
				CODEMP: this.filter.company,
				CODUNI: this.filter.unit,
				CODPLE: this.filter.strategicPlanning,
				CODPLA: this.registration.planning,
				DESCRI: this.registration.message,
				STATUS: this.registration.status,
				PEREXE: this.registration.percent,
			};

			this.loadingPlanningRegistration = true;

			const rest = this.registration.id
				? planActionRegistration.update({
						id: this.registration.id,
						...data,
				})
				: planActionRegistration.create(data);

			rest
				.then((response) => {
					if (!response) {
						return;
					}

					this.toast(
						"success",
						this.registration.id
							? "Movimentação atualizado com sucesso!"
							: "Movimentação adicionado com sucesso!"
					);
					this.registration.message = "";

					if (this.registration.status === "F") {
						this.closeRegistration();
						return;
					}

					this.getRegistration(this.registration.planning);
				})
				.catch(() => {
					this.loadingPlanningRegistration = false;
				});
		},
		getRegistration(planning) {
			const search = {};

			this.registrationPlanning = [];
			this.loadingPlanningRegistration = true;

			if (planning) {
				search.planning = planning;
			}

			return planActionRegistration.search(search).then((response) => {
				this.registrationPlanning = response;
				this.loadingPlanningRegistration = false;
			});
		},
	},
};
</script>

<style>
.aggroup {
	background-color: #eaeaea;
}

.aggroup > td {
	font-size: 0.805rem;
	height: 40px;
}

.aggroupLine > td {
	font-size: 0.755rem;
	height: 40px;
}

.borderRight {
	border-right: thin solid rgba(0, 0, 0, 0.12);
}

.colDialog {
	padding-top: 0px;
	padding-bottom: 0px;
}

.divToClick {
	cursor: pointer;
	padding-top: 10px;
	padding-bottom: 10px;
}

.breakLine {
	word-break: break-word;
}
</style>
